/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { styled } from 'styled-components';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  // TablePagination,
  TableRow,
  Paper,
} from '@mui/material';
import Pagination from '../Pagination';

const MainContainer = styled.div`
  width: 100%;
  margin: 10px auto;
  @media (max-width: 767px) {
    width: 100%;
    margin: 0;
  }
`;

const DataTable = ({
  data,
  contributionData,
  headers,
  // rowsPerPageOptions,
  onPageChange,
}) => {
  const [currentPage, setCurrentPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageOptions[0]);

  const handleChangePage = (selectedPage) => {
    setCurrentPage(selectedPage.selected);
    onPageChange(selectedPage.selected);
  };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(parseInt(event.target.value, 10));
  //   setCurrentPage(0);
  //   onPageChange(0);
  // };

  const pageCount = contributionData.totalPages;
  // const startIndex = currentPage * rowsPerPage;
  // const endIndex = startIndex + rowsPerPage;
  // const paginatedData = data.slice(startIndex, endIndex);

  return (
    <MainContainer>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow style={{ background: '#e3f0ff' }}>
              {headers.map((header) => (
                <TableCell
                  key={header}
                  sx={{ borderRight: '1px solid #ddd', fontWeight: 'bold' }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => (
              <TableRow
                key={row.id}
                sx={{ background: index % 2 === 1 ? '#f4f4f4' : '#ffffff' }}
              >
                <TableCell sx={{ borderRight: '1px solid #ddd' }}>
                  {row.column1}
                </TableCell>
                <TableCell sx={{ borderRight: '1px solid #ddd' }}>
                  {row.column2}
                </TableCell>
                <TableCell sx={{ borderRight: '1px solid #ddd' }}>
                  {row.column3}
                </TableCell>
                <TableCell sx={{ borderRight: '1px solid #ddd' }}>
                  {row.column4}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {/* <TablePagination
        sx={{
          '@media (max-width: 767px)': {
            '& .MuiTablePagination-toolbar': {
              padding: 0,
            },
          },
        }}
        rowsPerPageOptions={rowsPerPageOptions}
        component="div"
        count={totalRows}
        rowsPerPage={rowsPerPage}
        page={currentPage}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      /> */}
      <Pagination
        pageCount={pageCount}
        onPageChange={handleChangePage}
        forcePage={currentPage}
      />
    </MainContainer>
  );
};
DataTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  headers: PropTypes.arrayOf(PropTypes.string).isRequired,
  rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number).isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default DataTable;
